// Cursor.js
import React, { useEffect, useRef } from "react";

const Cursor = () => {
	const cursorRef = useRef(null);

	// Refs for positions
	const mouseX = useRef(window.innerWidth / 2);
	const mouseY = useRef(window.innerHeight / 2);
	const cursorX = useRef(window.innerWidth / 2);
	const cursorY = useRef(window.innerHeight / 2);

	useEffect(() => {
		const handleMouseMove = (e) => {
			mouseX.current = e.clientX;
			mouseY.current = e.clientY;
		};

		// Update mouse position on mousemove
		document.addEventListener("mousemove", handleMouseMove);

		return () => {
			// Clean up event listener
			document.removeEventListener("mousemove", handleMouseMove);
		};
	}, []);

	useEffect(() => {
		const lerp = (start, end, amt) => {
			return (1 - amt) * start + amt * end;
		};

		let reqId; // For cancelling the animation frame

		const render = () => {
			cursorX.current = lerp(cursorX.current, mouseX.current, 0.1);
			cursorY.current = lerp(cursorY.current, mouseY.current, 0.1);

			if (cursorRef.current) {
				cursorRef.current.style.transform = `translate3d(${cursorX.current}px, ${cursorY.current}px, 0)`;
			}

			reqId = requestAnimationFrame(render);
		};

		render();

		return () => {
			cancelAnimationFrame(reqId);
		};
	}, []);

	// Handling hover effects on interactive elements
	useEffect(() => {
		const interactiveElements = document.querySelectorAll(
			"a, button, Link, .button, .btn, .lnk, .swiper-pagination, .swiper-button-prev, .swiper-button-next"
		);

		const addCursorHoverClass = () => {
			if (cursorRef.current) {
				cursorRef.current.classList.add("cursor-zoom");
			}
		};

		const removeCursorHoverClass = () => {
			if (cursorRef.current) {
				cursorRef.current.classList.remove("cursor-zoom");
			}
		};

		interactiveElements.forEach((el) => {
			el.addEventListener("mouseenter", addCursorHoverClass);
			el.addEventListener("mouseleave", removeCursorHoverClass);
		});

		return () => {
			interactiveElements.forEach((el) => {
				el.removeEventListener("mouseenter", addCursorHoverClass);
				el.removeEventListener("mouseleave", removeCursorHoverClass);
			});
		};
	}, []);

	return <div className="cursor" ref={cursorRef}></div>;
};

export default Cursor;
